import { render, staticRenderFns } from "./detailPenarikanBarang.vue?vue&type=template&id=0711f236&scoped=true&"
import script from "./detailPenarikanBarang.js?vue&type=script&lang=js&"
export * from "./detailPenarikanBarang.js?vue&type=script&lang=js&"
import style0 from "./detailPenarikanBarang.scss?vue&type=style&index=0&id=0711f236&lang=scss&scoped=true&"
import style1 from "./detailPenarikanBarang.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711f236",
  null
  
)

export default component.exports